import { EVENTS } from "../events/baseEvents";
import eventsObservable from "../events/EventsObservable";
import SystemConfig, { CONFIG_PARAMS } from "./SystemConfig";

export const CLOSE_WINDOW_TYPES = {
  INNER_HOME: "innerhome",
  HOME: "home",
  MESSAGE: "message",
};

/**
 * @param config
 */
export function closeWindow(config: SystemConfig) {
  let backUrl = config.get(CONFIG_PARAMS.BACK_URL);
  let onHome = config.get(CONFIG_PARAMS.ON_HOME);
  let homeUrl = config.get(CONFIG_PARAMS.HOME_URL);

  if (backUrl) {
    window.top
      ? (window.top.location.href = backUrl)
      : (window.location.href = backUrl);
  } else if (homeUrl && CLOSE_WINDOW_TYPES.INNER_HOME === onHome) {
    window.location.href = homeUrl;
  } else if (homeUrl && CLOSE_WINDOW_TYPES.HOME === onHome) {
    window.top
      ? (window.top.location.href = homeUrl)
      : (window.location.href = homeUrl);
  } else if (CLOSE_WINDOW_TYPES.MESSAGE === onHome) {
    if (config.get(CONFIG_PARAMS.PLATFORM).includes("playtech")) {
      eventsObservable.dispatch(EVENTS.SEND_CLOSE_MSG);
      return;
    }

    if (config.get(CONFIG_PARAMS.PLATFORM) === "iforium") {
      window.parent.postMessage({ method: "game.end" }, "*");
    } else {
      window.parent && window.parent.postMessage({ action: "close" }, "*");
    }
  } else {
    window.top ? window.top.close() : window.close();
  }
}
